export var pluralize = function (value) {
    if (value === 1)
        return '';
    return 's';
};
